<template lang="pug">
	.available-courses-container
		top-bar(
			:state='topbarState'
			:scroll-top='scrollTop'
			@update-topbar='updateTopbar'
		)

		CoursesList(
			@scroll-topbar='scrollTopbar'
			:view="''"
			:courses='filteredCourses'
		)

		mobile-filters
</template>

<script>
import TopBar from '@/components/TopBar';
import CoursesList from '@/components/CoursesList';
import MobileFilters from '@/components/MobileFilters';

export default {
  name       : 'available-courses',
  components : {
    TopBar,
    CoursesList,
    MobileFilters
  },

  data : () => ( {
    topbarState : '',
    scrollTop   : 0,
  } ),

  computed : {
    searchResults() {
      return this.$store.getters.searchResults;
    },

    filteredCourses() {
      let courses = [];
      if ( this.searchResults ) courses = this.$store.getters.appliedFilters( this.searchResults );
      else courses = this.$store.getters.filteredCourses;
      return courses.sort( ( c1, c2 ) => ( c1.name > c2.name ? 1 : -1 ) );
    }
  },

  methods : {
    scrollTopbar( e ) {
      const { scrollTop } = e.target;
      const deltaY    = ( this.scrollTop - scrollTop );

      this.scrollTop = scrollTop;

      if ( this.topbarState === 'search' ) {
        return;
      }

      if ( scrollTop < 165 ) {
        this.topbarState = '';
        return;
      }

      if ( deltaY < 0 ) {
        this.topbarState = 'collapsed';
      }

      else {
        this.topbarState = '';
      }
    },

    updateTopbar( state ) {
      this.topbarState = state;
    }

  },
};
</script>

<style lang="scss" scoped>
	.available-courses-container {
		height: 100vh;
		display: flex;
		flex-direction: column;
		background: white;
	}
</style>
